import { useCallback, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

type UseRouteInfoResult = {
    currentPath: string;
    isActive: (urls: string[]) => boolean;
};

/**
 * Hook to get current route information and check if paths are active.
 * Uses React Router's useLocation directly for reliable route detection.
 */
export function useRouteInfo(): UseRouteInfoResult {
    const location = useLocation();
    const currentPath = location.pathname;

    const isActive = useCallback(
        (urls: string[]): boolean => {
            for (let i = 0; i < urls.length; i++) {
                if (currentPath.startsWith(urls[i])) {
                    return true;
                }
            }
            return false;
        },
        [currentPath],
    );

    return useMemo(
        () => ({
            currentPath,
            isActive,
        }),
        [currentPath, isActive],
    );
}
